import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useAuth } from "../../auth/auth";
import { getMyProfileData } from "../../api/apiCall";

const MyProfile = () => {
    const {state} = useAuth();
    const [profileData, setProfileData] = useState<any>();

    const getProfileData = async () => {
        const response = await getMyProfileData(state.user?.token);
        setProfileData(response);
    }

    useEffect(() => {
        getProfileData();
    }, []);

    return (
        <Box sx={{
            backgroundColor: "#fff",
            padding: "50px",
            margin: "auto",
            background: "#fff",
            border: '1px solid rgb(236, 236, 236)',
        }}>
            <Typography variant="h6" fontWeight={"bold"} mb={3}>
                Profile Details
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Full Name</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.name} {profileData?.surname}</Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Username</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.username}</Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Email</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.email}</Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Phone Number</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.phoneNumber}</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>PTS</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.pts}</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Post Code</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.postCode}</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Location</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography>{profileData?.location}</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}

export default MyProfile;
